import {
    INIT_IMAGE_RECT,
    UPDATE_IMAGE_RECT_POSITION,
    INIT_PROJECTION,
    APPLY_FORCED_SCALE,
} from './actions'
import {
    JUMP_TO_MEDIA,
    PREVIOUS_MEDIA,
    NEXT_MEDIA,
    JUMP_TO_GROUP,
    PREVIOUS_GROUP,
    NEXT_GROUP,
    FORWARD_MEDIA,
    BACKWARD_MEDIA,
    FIRST_MEDIA,
    LAST_MEDIA
} from '../navigation/actions'
import { set } from 'immutadot'
import { LOCK } from '../appliedFilters/actions'
import { Rectangle } from 'helpers/math'
import { RESET } from '../appliedFilters/actions'

const initialState = {
    imageRect: null,
    projections: null,
    locked: false,
}

export const canvas = (state = initialState, action) => {

    switch (action.type)
    {
        case LOCK:
            return set(state, 'locked', !state.locked)

        case JUMP_TO_MEDIA:
        case PREVIOUS_MEDIA:
        case NEXT_MEDIA:
        case BACKWARD_MEDIA:
        case FORWARD_MEDIA:
        case FIRST_MEDIA:
        case LAST_MEDIA:
        case JUMP_TO_GROUP:
        case PREVIOUS_GROUP:
        case NEXT_GROUP:
            if(state.locked !== true && state.imageRect !== null)
            {
                return set(state, 'imageRect', state.imageRect.reinitPos())
            }

            return state

        case RESET:
            if(state.imageRect instanceof Rectangle)
            {
                return set(state, 'imageRect', state.imageRect.reinitPos())
            }

            return state

        case INIT_IMAGE_RECT:
            const { imageRect } = action

            let newImageRect = new Rectangle(imageRect.width, imageRect.height)

            if(state.imageRect !== null)
            {
                newImageRect = newImageRect.moveTo(state.imageRect.position)
            }

            return set(state, 'imageRect', newImageRect)

        case INIT_PROJECTION:
            const { scale, frame, viewId } = action

            return set(state, `projections.${viewId}`, {defaultScale: scale, frame })

        case UPDATE_IMAGE_RECT_POSITION:
            const { position } = action

            return set(state, 'imageRect', state.imageRect.moveTo(position))

        case APPLY_FORCED_SCALE:
            return set(state, `projections.${action.viewId}.defaultScale`, action.scale)

        default:
            return state
    }
}
